import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'
import { humanizeEnum } from '@/lib/format'
import { toneForStatus, type BadgeTone } from './status-tone'
import styles from './StatusBadge.module.css'

export interface BadgeProps {
  tone?: BadgeTone
  children: ReactNode
  /** Adds a filled dot — used where a row has several badges to scan. */
  dot?: boolean
  className?: string
  title?: string
}

export function Badge({ tone = 'neutral', children, dot = false, className, title }: BadgeProps) {
  return (
    <span className={cn(styles.badge, styles[tone], className)} title={title}>
      {dot ? <span className={styles.dot} aria-hidden="true" /> : null}
      {children}
    </span>
  )
}

export interface StatusBadgeProps {
  status: string | null | undefined
  className?: string
  fallback?: string
}

export function StatusBadge({ status, className, fallback = 'Unknown' }: StatusBadgeProps) {
  return (
    <Badge tone={toneForStatus(status)} dot className={className}>
      {humanizeEnum(status, fallback)}
    </Badge>
  )
}
